import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { CNPrescription } from 'src/app/models/cnprescription';
import { CNPrescriptionEntry } from 'src/app/models/cnprescriptionentry';

@Component({
  selector: 'app-prescription-table',
  templateUrl: './prescription-table.component.html',
  styleUrls: ['./prescription-table.component.scss']
})
export class PrescriptionTableComponent implements OnInit, OnDestroy {

  private myPrescription: CNPrescription;
  public datasource: MatTableDataSource<CNPrescriptionEntry> = new MatTableDataSource();
  public entries: CNPrescriptionEntry[] = [];
  displayedColumns: string[] = ['entry'];

  private childAddedSubscription: Subscription;

  constructor() { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    if (this.childAddedSubscription) {
      this.childAddedSubscription.unsubscribe();
    }
  }

  @Input() set prescription(thePrescription: CNPrescription) {
    this.myPrescription = thePrescription;
    if (this.myPrescription) {
      this.loadEntries();
      this.childAddedSubscription = this.myPrescription.childAdded.subscribe(addedChild => {
        console.log('child added', addedChild);
        this.entries = this.myPrescription.childs$('SNItem.CNItem.CNPrescriptionEntry') as CNPrescriptionEntry[];
        this.datasource.data = this.entries;
      });
    }
  }

  loadEntries(): void {
    if (this.myPrescription.entries) {
      this.entries = this.myPrescription.entries;
      this.datasource.data = this.entries;
    } else {
      this.myPrescription.childs('SNItem.CNItem.CNPrescriptionEntry').subscribe(entries => {
        this.entries = entries as CNPrescriptionEntry[];
        this.datasource.data = this.entries;
      });
    }
  }

  entryRemoved(entry: CNPrescriptionEntry) {
    this.entries.splice(this.entries.indexOf(entry), 1);
    this.datasource.data = this.entries;
  }
}
